import { Link } from "react-router-dom";
import { Shield, Award, Wrench, Leaf, Sun, Cpu, Cloud, Smartphone } from "lucide-react";
import { PATIO_IMG } from "../lib/constants";

export default function Features() {
  const items = [
    { id: "garantia", i: Shield,    t: "5 év szerkezeti garancia", d: "Gondtalan tulajdonlás évekre." },
    { id: "alu",      i: Award,     t: "Eloxált alumínium",        d: "Korrózióálló, festett vagy faerezetű felülettel." },
    { id: "szereles", i: Wrench,    t: "Egyedi szerelés",          d: "Saját kivitelező csapat, kulcsrakész telepítés." },
    { id: "energia",  i: Leaf,      t: "Energiatakarékos",         d: "LED világítás és érzékelők." },
    { id: "vaszon",   i: Sun,       t: "Vízálló vászon",           d: "Opatex UV- és vízálló prémium kelmék." },
    { id: "somfy",    i: Cpu,       t: "SOMFY motor",              d: "Halk, ipari minőségű prémium meghajtás." },
    { id: "wind",     i: Cloud,     t: "Szélérzékelő",             d: "Erős szélre automatikusan reagál." },
    { id: "app",      i: Smartphone, t: "Mobil app",               d: "iOS és Android vezérlés egy érintéssel." },
    { id: "konzult",  i: Sun,       t: "Személyes konzultáció",    d: "Igény esetén személyes konzultációt biztosítunk." },
  ];

  return (
    <div data-testid="features-page" className="bg-[#031a20]">
      <section
        className="relative h-[50vh] min-h-[360px] bg-cover bg-no-repeat bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(3,26,32,0.6), rgba(3,26,32,0.8)), url(${PATIO_IMG})`,
        }}
      >
        <div className="max-w-7xl mx-auto px-6 sm:px-8 h-full flex flex-col justify-end pb-16">
          <div className="text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-4">
            <span className="gold-rule" />Jellemzők
          </div>
          <h1 className="font-serif text-5xl sm:text-6xl text-white">A részletekben rejlik a luxus.</h1>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map(({ id, i: Icon, t, d }) => (
            <div key={id} className="bg-[#04222a] border border-white/10 p-8">
              <Icon className="w-7 h-7 text-[#d4af37] mb-6" strokeWidth={1.5} />
              <div className="font-serif text-xl text-white">{t}</div>
              <p className="text-sm text-white/70 mt-3 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
        <div className="max-w-3xl mx-auto px-6 text-center mt-20">
          <Link
            to="/termek"
            data-testid="features-cta-button"
            className="inline-block bg-[#d4af37] hover:bg-[#e5c865] text-[#031a20] px-10 py-5 uppercase tracking-[0.2em] text-xs transition-colors font-medium"
          >
            Indítom a konfigurátort
          </Link>
        </div>
      </section>
    </div>
  );
}
